<app-simple-stacked-bar-chart
  [data]="data"
  [loading]="isLoading"
  [leftLabel]="'charts.labels.canonicals' | translate"
  [rightLabel]="'charts.labels.count' | translate"
></app-simple-stacked-bar-chart>
